import { Flex, Skeleton, SkeletonText } from "@chakra-ui/react"
import React from "react"

interface Props {}

const ProductFeedSkeleton: React.FC<Props> = () => {
  return (
    <Flex
      gap={{ base: 6, md: 10 }}
      py="2rem"
      flexDirection={{ base: "column", md: "row" }}
    >
      <Flex>
        <Skeleton
          height={{ base: "200px", md: "400px" }}
          width={{ base: "full", md: "400px" }}
          borderRadius="xl"
        />
      </Flex>

      <Flex flexDirection="column" gap={4} w="full">
        <Skeleton height="20px" width="80%" order={{ base: 1 }} />

        <Flex gap={3} order={{ base: 2 }}>
          <Skeleton height="20px" width="60px" />
          <Skeleton height="20px" width="60px" />
          <Skeleton height="20px" width="60px" />
        </Flex>

        <Flex
          py={2}
          flexDirection={{ base: "column", md: "row" }}
          order={{ base: 3, md: 10 }}
          gap={3}
        >
          <Skeleton
            height="50px"
            width={{ base: "full", md: "160px" }}
            borderRadius="md"
          />
          <Skeleton
            height="50px"
            width={{ base: "full", md: "160px" }}
            borderRadius="md"
          />
        </Flex>

        <SkeletonText
          noOfLines={3}
          spacing="4"
          skeletonHeight="2"
          order={{ base: 4, md: 9 }}
        />

        <Skeleton height="20px" width="80%" order={{ base: 5, md: 11 }} />

        <SkeletonText
          noOfLines={{ base: 6, md: 7 }}
          spacing="4"
          skeletonHeight="2"
          order={{ base: 6, md: 12 }}
        />
      </Flex>
    </Flex>
  )
}

export default ProductFeedSkeleton
